// reducer.js
const initialState = {
  transcriptData: '',
  lastUpdated: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SEND_TRANSCRIPT_DATA':
      return {
        ...state,
        transcriptData: action.payload,
        lastUpdated: Date.now()
      };

    default:
      return state;
  }
};

export default reducer;
